module.exports = require("bootstrap-colorpicker");